/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeDefinitionForNumber extends models.AttributeDefinitionBase {
    constructor() {
        super();
        this.setDiscriminator("AttributeDefinitionForNumber");
    }

    getFixupPrototypeFunction() { return AttributeDefinitionForNumber.fixupPrototype; }

    static newInstance(model: Partial<AttributeDefinitionForNumber>): AttributeDefinitionForNumber {
        let obj = Object.assign(new AttributeDefinitionForNumber(), model);
        AttributeDefinitionForNumber.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeDefinitionForNumber>): AttributeDefinitionForNumber {
        if (!model) return null;
        return AttributeDefinitionForNumber.newInstance(<AttributeDefinitionForNumber> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeDefinitionForNumber) {
        if (!obj) return;

        models.AttributeDefinitionForNumber.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeDefinitionForNumber): boolean {
        if (models.AttributeDefinitionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttributeDefinitionForNumber.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.min === undefined) {
            this.min = 0;
        }
        if (this.max === undefined) {
            this.max = 0;
        }
    }

    /**
     * Minimum allowed value
     */
    min: number;

    /**
     * Maximum allowed value
     */
    max: number;

}
